$(function () {
  $('[data-toggle="main-page-slider"]').slick({
    dots: true,
    infinite: true,
    arrows: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    prevArrow: "<button type=\"button\" class=\"slick-prev\"><i class=\"ico-arrow-left\"></i></button>",
    nextArrow: "<button type=\"button\" class=\"slick-next\"><i class=\"ico-arrow-right\"></i></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false
        }
      }
    ]
  });

  var bLazy = new Blazy({
    selector: '.b-lazy',
  });

  $('[data-toggle="main-page-slider"]').on('afterChange', bLazy.revalidate);
})
